// Imported FIRST in index.js so React.lazy is wrapped before any screen module calls it (#2713).
import { installLazyRetry } from './lazyRetry';

installLazyRetry();
